import React from "react";
import type { ChakraProps, GridProps } from "@chakra-ui/react";
import { Grid as CUIGrid, GridItem } from "@chakra-ui/react";

type Props = GridProps &
  ChakraProps & {
    noGridItem?: boolean;
  };

export const Grid: React.FC<Props> = ({
  gridTemplateColumns,
  children,
  noGridItem = false,
  gap = 0,
  bgColor,
  ...chakraProps
}) => (
  <CUIGrid
    w="full"
    gridTemplateColumns={gridTemplateColumns}
    data-testid="grid/index"
    flexDirection="column"
    backgroundColor={bgColor}
    {...(noGridItem && { ...chakraProps })}
    gap={gap}
  >
    {noGridItem ? (
      children
    ) : (
      <>
        <GridItem />
        <GridItem {...chakraProps}>{children}</GridItem>
        <GridItem />
      </>
    )}
  </CUIGrid>
);
